import React, { useEffect, useState } from "react"
import PageMetaTags from "components/PageMetaTags"
import { Container, Row, Col, Input } from "reactstrap"
import BreadcrumbTitle from "components/BreadcrumbTitle"
import { withRouter, generatePath } from "react-router-dom"
import { SaveButton } from "components/Buttons"
import TableComponent from "components/Table"
import pollListColumns from "./pollListColumns"
import { getPollList, resetPollList } from "store/actions"
import { connect } from "react-redux"
import { URL_PATHS } from "constants/index"

const PollList = ({ history, pollList, getPollList, resetPollList, match }) => {
  const { event_id } = match?.params
  const [searchValue, setSearchValue] = useState("")
  const [showResetButton, setShowResetButton] = useState(false)
  const [defaultOrder, setDefaultOrder] = useState({
    o: "created_at",
    od: "asc",
  })

  useEffect(() => {
    getPollList({
      all: true,
      page: 1,
      per_page: 25,
      event_id: event_id,
      o: "created_at",
      od: "asc",
    })
    return () => {
      resetPollList()
    }
  }, [])

  const handleSearch = () => {
    if (searchValue.trim().length) {
      getPollList({
        ...defaultOrder,
        page: 1,
        per_page: 25,
        all: true,
        event_id: event_id,
      })
      setShowResetButton(true)
    }
  }

  const handleResetSearch = () => {
    getPollList({
      all: true,
      page: 1,
      per_page: 25,
      event_id: event_id,
      ...defaultOrder,
    })
    setSearchValue("")
    setShowResetButton(false)
  }

  const handlePageChange = page => {
    getPollList({
      page: page,
      per_page: 25,
      ...defaultOrder,
      all: true,
      event_id: event_id,
      ...(showResetButton ? { s: searchValue } : {}),
    })
  }

  const handleSort = (type, { sortField, sortOrder }) => {
    getPollList({
      o: sortField,
      od: sortOrder,
      page: 1,
      per_page: 25,
      all: true,
      event_id: event_id,
      ...(showResetButton ? { s: searchValue } : {}),
    })
    setDefaultOrder({ o: sortField, od: sortOrder })
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <PageMetaTags title="Polls" />
        <Container fluid>
          <BreadcrumbTitle
            title="Polls"
            breadcrumbItems={[
              { title: "Dashboard" },
              {
                title: "Experience Reports",
                link: generatePath(URL_PATHS.EVENT_REPORTS, { id: event_id }),
              },
              { title: "Polls" },
            ]}
          />
          <Row className="d-flex justify-content-end">
            <Col xs="auto">
              <SaveButton
                type="button"
                color="light"
                content="Back"
                onClick={() => {
                  history.goBack()
                }}
              />
            </Col>
          </Row>
          <Row className="d-flex justify-content-center my-2">
            <Col xl={2} md={3} sm={4} xs={4}>
              <Input
                value={searchValue}
                onChange={event => {
                  setSearchValue(event.target.value)
                }}
                placeholder="Poll Name"
              />
            </Col>
            <Col xs="auto">
              <SaveButton
                type="button"
                content="Search"
                onClick={handleSearch}
              />
            </Col>
            {showResetButton && (
              <Col xs="auto">
                <SaveButton
                  type="button"
                  content="Reset"
                  color="light"
                  onClick={handleResetSearch}
                />
              </Col>
            )}
          </Row>
          <Row className="my-3">
            <Col>
              <TableComponent
                data={pollList?.data}
                columns={pollListColumns({
                  history: history,
                  event_id: event_id,
                })}
                paginationData={{
                  current_page: pollList?.current_page,
                  last_page: pollList?.last_page,
                  total_items: pollList?.total,
                  items_per_page: pollList?.per_page,
                  from: pollList?.from,
                  to: pollList?.to,
                  first_page: 1,
                }}
                onPageChange={handlePageChange}
                onTableSort={handleSort}
              />
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

const mapStateToProps = state => ({
  pollList: state.Poll.pollList,
})

const mapDispatchToProps = dispatch => ({
  getPollList: values => dispatch(getPollList(values)),
  resetPollList: () => dispatch(resetPollList()),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(PollList))
